import React from 'react';
import { Alert, Button, Spin } from 'antd';
import { useHistory } from 'react-router-dom';

import { useCurrentSubscription, usePermission } from 'hooks';
import { Scope, SubscriptionStatus } from 'redux/reducers/authReducer';
import { usePromo, useSavePlanChange } from './hooks';

export function PlanOffer() {
  const subscription = useCurrentSubscription();
  const hasPermissionManageSubscription = usePermission(Scope.OrganizationManageSubscription);

  if (subscription.status !== SubscriptionStatus.Unsubscribed && subscription.status !== SubscriptionStatus.Free) {
    return <></>;
  }

  if (!hasPermissionManageSubscription) {
    return <></>;
  }

  return <PlanOfferDisplay />;
}

export function PlanOfferDisplay() {
  const subscription = useCurrentSubscription();
  const { data, loading } = usePromo();
  const { isSaving, save } = useSavePlanChange();
  const history = useHistory();

  const handleActivate = async () => {
    await save(data?.code!);
    history.push('/subscription');
    window.location.reload();
  };

  if (subscription.status !== SubscriptionStatus.Unsubscribed && subscription.status !== SubscriptionStatus.Free) {
    return <></>;
  }

  if (loading) {
    return <Spin spinning={loading} />;
  }

  if (!data) {
    return <></>;
  }

  return (
    <Alert
      message={data.name}
      type="warning"
      showIcon
      description={<div dangerouslySetInnerHTML={{ __html: data.description }} />}
      action={
        <Button size="small" type="link" onClick={handleActivate} disabled={isSaving}>
          Activate it now!
        </Button>
      }
    />
  );
}
